import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { Bank } from '@/types';
    import { router } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import ConnectEconomic from './ConnectEconomic.vue';
    import ContinueButton from '@/components/ContinueButton.vue';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import Permission from '@/enums/Permission';

    interface Props {
        bank: Bank;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BankTableActions',
  props: {
    bank: {}
  },
  setup(__props: any) {

    const props = __props;

    const { hasAnyPermission } = usePermissions();

    function handleTransactions() {
        router.visit(route('v2.transactions.index', { account_id: props.bank.id }));
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.bank }, {
    default: _withCtx(() => [
      (
                _unref(hasAnyPermission)([
                    _unref(Permission).BANK_CREATE,
                    _unref(Permission).BANK_UPDATE,
                    _unref(Permission).BANK_DELETE,
                ])
            )
        ? (_openBlock(), _createBlock(ConnectEconomic, {
            key: 0,
            bank: _ctx.bank
          }, null, 8, ["bank"]))
        : _createCommentVNode("", true),
      _createVNode(ContinueButton, { onClick: handleTransactions }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('viia.transactions.page_header')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})